import React from 'react';

interface Props {
	size: number;
}

export const TechnologyIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>technology</title>
		<path d='M20.2 16.51H4.31a1.87 1.87 0 01-1.86-1.86V5.5a1.87 1.87 0 011.86-1.86H20.2a1.87 1.87 0 011.86 1.86v9.15a1.87 1.87 0 01-1.86 1.86zM4.31 4.47a1 1 0 00-1 1v9.15a1 1 0 001 1H20.2a1 1 0 001-1V5.5a1 1 0 00-1-1z' />
		<path d='M22.46 20.36H1.54A1.38 1.38 0 01.16 19a1.4 1.4 0 01.3-.86L2 16.19a1.41 1.41 0 011.08-.51H21.3a1.38 1.38 0 011.19.67l1.15 1.92a1.37 1.37 0 01-.47 1.89 1.39 1.39 0 01-.71.2zM3.08 16.51a.55.55 0 00-.43.2l-1.54 1.93A.54.54 0 001 19a.55.55 0 00.55.55h20.91a.54.54 0 00.28-.08.51.51 0 00.25-.34.49.49 0 00-.06-.41l-1.15-1.93a.56.56 0 00-.48-.26z' />
		<path d='M19.64 18.19h-15a.41.41 0 01-.41-.41.41.41 0 01.41-.42h15a.42.42 0 01.42.42.41.41 0 01-.42.41z' />
		<g>
			<path d='M14.51 12.6a.43.43 0 01-.28-.11.4.4 0 010-.58l1.56-1.77-1.59-1.76a.4.4 0 010-.58.41.41 0 01.59 0l1.81 2a.41.41 0 010 .55l-1.81 2a.43.43 0 01-.28.25zM10.43 12.6a.43.43 0 01-.31-.14l-1.81-2a.41.41 0 010-.55l1.81-2a.41.41 0 01.62.55l-1.57 1.68 1.57 1.77a.41.41 0 010 .58.43.43 0 01-.31.11zM11.79 13.28h-.1a.41.41 0 01-.3-.5l1.24-5.29a.42.42 0 01.5-.31.43.43 0 01.31.5L12.19 13a.41.41 0 01-.4.28z' />
		</g>
	</svg>
);
